(function () {
  if (window.__w1gkTiktokInit) return;
  window.__w1gkTiktokInit = true;

  function playerSrc(id) {
    const q = new URLSearchParams({
      music_info: '0',
      description: '0',
      controls: '1',
      progressive: '0',
      autoplay: '0',
      loop: '0',
      rel: '0',
    });
    return 'https://www.tiktok.com/player/v1/' + encodeURIComponent(id) + '?' + q.toString();
  }

  function mount(el) {
    if (!el || el.dataset.mounted === '1') return;
    const id = el.getAttribute('data-tiktok-id');
    if (!id) return;
    el.dataset.mounted = '1';
    el.classList.add('is-playing');

    const iframe = document.createElement('iframe');
    iframe.src = playerSrc(id);
    iframe.title = 'TikTok W1GK';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('scrolling', 'no');
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    el.innerHTML = '';
    el.appendChild(iframe);
  }

  function bind() {
    const embeds = Array.prototype.slice.call(
      document.querySelectorAll('[data-w1gk-tiktok-embed][data-tiktok-id]')
    );
    if (!embeds.length) return;

    const track = document.querySelector('.w1gk-about-community__track');

    if (!('IntersectionObserver' in window)) {
      embeds.forEach(mount);
      return;
    }

    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          mount(entry.target);
          io.unobserve(entry.target);
        });
      },
      {
        root: track || null,
        rootMargin: '40% 80% 40% 80%',
        threshold: 0.01,
      }
    );

    embeds.forEach(function (el, i) {
      if (i < 4) mount(el);
      else io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
